module.exports = __webpack_public_path__ + "static/opener-text-b89060ed3209ffc31c613e4ccf27ebf8.png";